import { theme } from 'theme'

export const gradientColorsMapping = {
  Gold: [theme.colors.gold, theme.colors.goldDark],
  Aquamarine: [theme.colors.aquamarine, theme.colors.aquamarineDark],
  SkyBlue: [theme.colors.skyBlue, theme.colors.skyBlueDark],
  DeepPink: [theme.colors.deepPink, theme.colors.deepPinkDark],
  Coral: [theme.colors.coral, theme.colors.coralDark],
  Lilac: [theme.colors.lilac, theme.colors.lilacDark],
}
